import { apiPost } from "./client";

export function postOpportunity(data) {
  return apiPost("/opportunities/", data);
}

export function postOpportunityLineItem(data) {
  return apiPost("/opportunitylineitems/", data);
}
